import Vue from 'vue'
import VueI18n from 'vue-i18n'

import de from 'vuetify/lib/locale/de'
import en from 'vuetify/lib/locale/en'
import zhHans from 'vuetify/es5/locale/zh-Hans'
import nl from 'vuetify/lib/locale/nl'
import vi from 'vuetify/lib/locale/vi'
import dayjs from 'dayjs'

Vue.use(VueI18n)

export function loadTransLangs () {
  return require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
    .keys()
    .map(item => item.match(/([A-Za-z0-9-_]+)\./i)[1].toLowerCase())
    .filter(lang => lang && lang.length > 1)
}

const messages = {
  en: {
    ...require('@/locales/en.json'),
    $vuetify: en,
  },
  de: {
    ...require('@/locales/de.json'),
    $vuetify: de,
  },
  zh: {
    ...require('@/locales/zh.json'),
    $vuetify: zhHans,
  },
  nl: {
    ...require('@/locales/nl.json'),
    $vuetify: nl,
  },
  vi: {
    ...require('@/locales/vi.json'),
    $vuetify: vi,
  },
}

function loadNumberFormats () {
  const numberFormats = {}
  return loadTransLangs().forEach(lang => {
    numberFormats[lang] = {
      currency: {
        style: 'currency',
        currency: 'EUR',
      },
    }
  })
}

const numberFormats = loadNumberFormats()

require('dayjs/locale/de')
require('dayjs/locale/zh')
require('dayjs/locale/en')
require('dayjs/locale/nl')


dayjs.locale(localStorage.getItem('frontEndLang')?.toLowerCase())

export default new VueI18n({
  locale: localStorage.getItem('frontEndLang')?.toLowerCase() || 'zh',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'zh',
  messages,
  numberFormats,
  // silentTranslationWarn: true,
})
